"use strict";

var _regeneratorRuntime2 = require("@babel/runtime/regenerator");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authWatcher = authWatcher;
exports.changePassword = changePassword;
exports.refreshSession = refreshSession;
exports.signIn = signIn;
exports.signOut = signOut;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _effects = require("redux-saga/effects");
var _Auth = require("../../../services/Auth");
var _variables = require("../variables");
var _helpers = require("@qwkin/helpers");
var _variables2 = require("../../Notification/variables");
var _utils = require("../../../utils");
var _variables3 = require("../../Community/variables");
var _variables4 = require("../../Resource/variables");
var _marked = /*#__PURE__*/_regeneratorRuntime2.mark(authWatcher);
function signIn(_ref) {
  var payload = _ref.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var response, _response$data, _response;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.call)(_Auth.AuthService.signIn, payload);
        case 3:
          response = _context.sent;
          _context.next = 6;
          return (0, _effects.put)({
            type: _variables.SIGNIN_SUCCESS,
            payload: response
          });
        case 6:
          _context.next = 8;
          return (0, _effects.put)({
            type: _variables4.LOAD_PHONE_REGIONS_REQUEST
          });
        case 8:
          _context.next = 17;
          break;
        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](0);
          _response = _context.t0.response;
          _context.next = 15;
          return (0, _effects.put)({
            type: _variables.SIGNIN_FAIL,
            payload: _response
          });
        case 15:
          _context.next = 17;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response$data = _response === null || _response === void 0 ? void 0 : _response.data) !== null && _response$data !== void 0 ? _response$data : {}),
              data: _response
            }
          });
        case 17:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 10]]);
  })();
}
function refreshSession(_ref3) {
  var payload = _ref3.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
    var response, _response2$data, _response2;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.call)(_Auth.AuthService.refreshSession, payload);
        case 3:
          response = _context2.sent;
          _context2.next = 6;
          return (0, _effects.put)({
            type: _variables.REFRESH_SESSION_SUCCESS,
            payload: response
          });
        case 6:
          _context2.next = 15;
          break;
        case 8:
          _context2.prev = 8;
          _context2.t0 = _context2["catch"](0);
          _response2 = _context2.t0.response;
          _context2.next = 13;
          return (0, _effects.put)({
            type: _variables.REFRESH_SESSION_FAIL,
            payload: _response2
          });
        case 13:
          _context2.next = 15;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response2$data = _response2 === null || _response2 === void 0 ? void 0 : _response2.data) !== null && _response2$data !== void 0 ? _response2$data : {}),
              data: _response2
            }
          });
        case 15:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 8]]);
  })();
}
function changePassword(_ref5) {
  var payload = _ref5.payload,
    _ref5$callback = _ref5.callback,
    callback = _ref5$callback === void 0 ? _helpers.identity : _ref5$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
    var response, _response3$data, _response3;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return (0, _effects.call)(_Auth.AuthService.changePassword, payload);
        case 3:
          response = _context3.sent;
          _context3.next = 6;
          return (0, _effects.put)({
            type: _variables.CHANGE_PASSWORD_SUCCESS,
            payload: response
          });
        case 6:
          _context3.next = 8;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Password changed successfully'
            }
          });
        case 8:
          callback();
          _context3.next = 18;
          break;
        case 11:
          _context3.prev = 11;
          _context3.t0 = _context3["catch"](0);
          _response3 = _context3.t0.response;
          _context3.next = 16;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response3$data = _response3 === null || _response3 === void 0 ? void 0 : _response3.data) !== null && _response3$data !== void 0 ? _response3$data : {}),
              data: _response3
            }
          });
        case 16:
          _context3.next = 18;
          return (0, _effects.put)({
            type: _variables.CHANGE_PASSWORD_FAIL,
            payload: _response3
          });
        case 18:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 11]]);
  })();
}

// TODO: USE SIGNOUT ENDPOINT
function signOut(_ref7) {
  var payload = _ref7.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
    var response;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return (0, _effects.put)({
            type: _variables.SIGNOUT_SUCCESS
          });
        case 3:
          _context4.next = 5;
          return (0, _effects.put)({
            type: _variables3.CLEAR_NOTICE_DRAFT_SUCCESS
          });
        case 5:
          _context4.next = 12;
          break;
        case 7:
          _context4.prev = 7;
          _context4.t0 = _context4["catch"](0);
          response = _context4.t0.response;
          _context4.next = 12;
          return (0, _effects.put)({
            type: _variables.SIGNOUT_FAIL,
            payload: response
          });
        case 12:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[0, 7]]);
  })();
}
function authWatcher() {
  return _regenerator["default"].wrap(function authWatcher$(_context5) {
    while (1) switch (_context5.prev = _context5.next) {
      case 0:
        _context5.next = 2;
        return (0, _effects.all)([(0, _effects.takeLatest)(_variables.SIGNIN_REQUEST, signIn), (0, _effects.takeLatest)(_variables.SIGNOUT_REQUEST, signOut), (0, _effects.takeLatest)(_variables.CHANGE_PASSWORD_REQUEST, changePassword), (0, _effects.takeLatest)(_variables.REFRESH_SESSION_REQUEST, refreshSession)]);
      case 2:
      case "end":
        return _context5.stop();
    }
  }, _marked);
}